angular.module('env.data.repos.users', [])

    .service('usersRepository', function ($q, rest, authService) {
        var _this = this;
        var modelType = 'UserModel';
        var modelTypeLite = 'UserModelLite';
        var modelDefinition = rest.getDefinition(modelType);

        /**
         * Get users
         * @returns {!Promise.<RepresentationModel[]>} Promise of collection of User Models
         */
        _this.getUsers = function () {
            return rest.map(modelDefinition).willReturn(modelType).get();
        };

        /**
         * Get user by id
         * @param {string} id id of the user
         * @returns {!Promise.<RepresentationModel>} Promise of User Model
         */
        _this.getUser = function (id) {
            return rest.map(modelDefinition).map(id).willReturn(modelType, id).get();
        };

        /**
         * Save the user
         * @param {RepresentationModel} user Representation model of the user
         * @returns {!Promise.<RepresentationModel>} Promise of saving success
         */
        _this.saveUser = function (user) {
            return rest.map(modelDefinition).save(user);
        };

        /**
         * Get UserGroups of the user
         * @param {string|RepresentationModel} user User Model or User Id
         * @returns {!Promise.<string[]>} Promise collection of user groups(array of strings)
         */
        _this.getUsersGroups = function (user) {
            return rest.map(modelDefinition).map(user).map('groups').get();
        };

        /**
         * Get centres of the user
         * @param {string|RepresentationModel} user User Model or User Id
         * @returns {!Promise.<RepresentationModel[]>} Promised collection of centres
         */
        _this.getUserCentres = function (user) {
            return rest.map(modelDefinition).map(user).map('centres').willReturn('CentreModel').get();
        };

        /**
         * Get customers of the user
         * @param {string|RepresentationModel} user User Model or User Id
         * @returns {!Promise.<RepresentationModel[]>} Promised collection of customers
         */
        _this.getUserCustomers = function (user) {
            return rest.map(modelDefinition).map(user).map('customers').willReturn('CustomerModel').get();
        };

        /**
         * Get role of the user
         * @param {string|RepresentationModel} user User Model or User Id
         * @returns {!Promise.<Object>} Promised user role (string)
         */
        _this.getUserRole = function (user) {
            return rest.map(modelDefinition).map(user).map('role').get();
        };

        /**
         * Get permissions of the user
         * @param {string|RepresentationModel} user User Model or User Id
         * @returns {!Promise.<Object[]>} Promised collection of user permissions
         */
        _this.getUserPermissions = function (user) {
            return rest.map(modelDefinition).map(user).map('permissions').get();
        };

        //region Current user

        var currentUser;
        authService.events.on('login', function () {
            currentUser = null;
        });
        authService.events.on('loginFailed', function () {
            currentUser = null;
        });
        authService.events.on('logout', function () {
            currentUser = null;
        });

        /**
         * Get current user from the server
         * @param {boolean} [refresh] force reload current user
         * @returns {!Promise.<RepresentationModel>} promise
         */
        _this.getCurrentUser = function (refresh) {
            if (currentUser) {
                if (_.isPromise(currentUser) || !refresh) {
                    return $q.when(currentUser);
                }
            }
            if (!authService.getToken()) {
                return $q.reject("Not authorized. Auth token is undefined.");
            }
            currentUser = rest.map(modelDefinition).map("current").willReturn(modelType).get();
            currentUser.then(
                function (user) {
                    currentUser = user;
                    return currentUser;
                },
                function (resp) {
                    currentUser = null;
                    return $q.reject(resp);
                });
            return currentUser;
        };

        /**
         * Save the current user
         * @returns {!Promise.<RepresentationModel>} promise
         */
        _this.saveCurrentUser = function () {
            if (currentUser && currentUser.isRepresentationModel == true) {
                var savePromise = rest.map(modelDefinition).save(currentUser);
                savePromise.then(function (user) {
                    if (user && user.isRepresentationModel == true) {
                        currentUser = user;
                    }
                });
                return savePromise
            }
            throw new Error("Not authorised");
        };

        //endregion

        //Ordering statistics

        /**
         * Get users statistics
         * @param {string} [whereOrderItems] 'Where' query to filter out the order items set for statistics. Optional.
         * @param {[]} [forUsers] Array of users Ids to get stats for.
         * @returns {!Promise.<Object[]>} promise of users statistics
         */
        _this.getUsersStatistics = function (whereOrderItems, forUsers) {
            if (whereOrderItems === null) {
                whereOrderItems = '';
            }
            if (forUsers == null) {
                forUsers = [];
            }

            return rest.map('users', 'statistics').post({where: whereOrderItems, users: forUsers});
        };

        //endregion

        //region Search

        var searchQueryCache = [];
        /**
         * Search users
         * @param {{where: string, orderBy: string, pageNumber: number, rowsPerPage: number}} query
         * @returns {!Promise} promise of search results
         */
        _this.search = function (query) {
            var executing = _.find(searchQueryCache, function (q) {
                return _.isEqual(q.query, query);
            });
            if (executing) {
                return executing.promise
                    .then(function (resp) {
                        return _.clone(resp); // clone to prevent modification of response content
                    });
            }

            //Here we map returned data to the lightweight usermodel to avoid excessive data fetching from rest api
            //and just have direct properties of the user and its customfields
            var p = rest
                .map(modelDefinition)
                .map('search')
                .willReturn(modelTypeLite)
                .search(query)
                .then(function (resp) {
                    searchQueryCache = _.reject(searchQueryCache, function (q) {
                        return _.isEqual(q.query, query);
                    });
                    return _.clone(resp);
                }, function (err) {
                    searchQueryCache = _.reject(searchQueryCache, function (q) {
                        return _.isEqual(q.query, query);
                    });
                    return $q.reject(err);
                });

            searchQueryCache.push({
                query: _.clone(query),
                promise: $q.when(p)
            });

            return $q.when(p);
        };

        //endregion


        return _this;
    })

    .run(function (rest, requestCoupler, requestCouplerUtils) {
        var baserUrl = om.config.build.baseUrl;
        var userUrl = rest.getDefinition('UserModel').getUrl();

        requestCoupler.addCoupler(requestCouplerUtils.createSimpleGetCollectionCoupler(userUrl, baserUrl + '/' + userUrl));
        requestCoupler.addCoupler(requestCouplerUtils.createCustomFieldsCollectionCoupler(userUrl, 'customfields', baserUrl + "/" + userUrl + '/customfields'));
    })

;
